import { updateTagsForDRPLeads } from './updateLeadsForDRP'

export function setDeclarativesForStorage() {
  const allianzFormActionsJSON = localStorage.getItem('allianzFormActions')

  if (
    allianzFormActionsJSON &&
    typeof DFI !== 'undefined' &&
    typeof window.DFI.labels !== 'undefined'
  ) {
    const allianzFormActions = JSON.parse(allianzFormActionsJSON)

    if (
      typeof window.DFI != 'undefined' &&
      typeof window.DFI.labels != 'undefined'
    ) {
      window.DFI.labels.EDeclaratives = {
        ...DFI.labels.EDeclaratives,
        ...allianzFormActions
      };
      

      delete window.DFI.labels.EDeclaratives.idTag

      if (typeof updateTagsForDRPLeads === 'function') {
        updateTagsForDRPLeads()
      } else {
        console.warn('updateTagsForDRPLeads no está definida')
      }
    } else {
      console.warn('window.DFI.labels no está definido')
    }
  } else {
    console.log('allianzFormActions no encontrado en local storage')
  }
}
